import ErrorPage from '@account/components/common/ErrorPage';
import Loading from '@components/common/Loading';
import React, {useEffect} from 'react';
import {Routes} from '@account/utils/route';
import {
  getOriginQueryParam,
  hasSentinelHubUser,
  openLinkingFlow,
} from '@account/utils/sentinel-hub';
import {trackEvent} from '@account/analytics';
import {useAuth} from '@apps-common/auth-react';
import {useHistory} from 'react-router-dom';
import {useSentinelHubUser} from '@account/hooks/data/sentinel-hub/useSentinelHubUser';
import {useUserHasActivePlansContracts} from '@hooks/users/useUserHasActivePlansContracts';

export const SENTINEL_HUB_REDIRECT_MESSAGE = 'Linking...';

const SentinelHubRedirectPage = () => {
  const auth = useAuth();
  const claims = auth.user?.claims;
  const shUserId = claims?.sh_user_id;

  useEffect(() => {
    trackEvent('Sentinel Hub: Redirect to check link', {
      origin: getOriginQueryParam(),
      sh_user_id: shUserId,
    });
  }, [shUserId]);

  const history = useHistory();

  const isLinked = hasSentinelHubUser(claims);

  const {isLoading: isLoadingSentinelHubUser} = useSentinelHubUser({
    enabled: isLinked,
  });

  const {
    isLoading: isLoadingPlansContracts,
    error,
    hasActivePlansContracts,
  } = useUserHasActivePlansContracts();

  const isLoading =
    (isLinked && !!isLoadingSentinelHubUser) || isLoadingPlansContracts;

  useEffect(() => {
    // stay on this page if loading
    if (isLoading) return;

    //redirect to ROOT if user is inactive
    if (!hasActivePlansContracts) {
      history.push(Routes.ROOT);
      return;
    }

    // redirect to user settings if user is active and linked
    if (isLinked) {
      history.push(Routes.USER_SETTINGS);
      return;
    }

    // redirect to linking flow if user is active but not linked
    if (hasActivePlansContracts && !isLinked) {
      try {
        openLinkingFlow(getOriginQueryParam());
      } catch (error) {
        trackEvent('Sentinel Hub: User failed to link to Sentinel Hub', {
          origin: getOriginQueryParam(),
        });
        return;
      }
      return;
    }
  }, [history, isLinked, hasActivePlansContracts, isLoading, shUserId]);

  const showLoading = isLoading || !error;

  return (
    <>
      {showLoading && (
        <Loading message={SENTINEL_HUB_REDIRECT_MESSAGE} includeDescription />
      )}
      {!!error && <ErrorPage />}
    </>
  );
};

export default SentinelHubRedirectPage;
